import React from "react";
import OurProcess from "../components/OurProcess";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";

function ProcessPage() {
  return (
    <>
      <section className="hidden lg:block">
        <Navbar />
      <Warning/>

      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <OurProcess />
      <Footer/>
    </>
  );
}

export default ProcessPage;
